import { CATEGORY_PROMPTS, THEME_PROMPTS } from 'config/vibePrompt';
import { ThemeKey } from 'config/themeColors';
import { useAppStore } from 'stores/appStore';

export function buildVibePrompt(): string {
  const {
    selectedCategory: category,
    selectedThemeKey: themeKey,
    selectedStoreName: siteName,
  } = useAppStore.getState();
  const categoryPrompt = category ? CATEGORY_PROMPTS[category] : undefined;
  const themePrompt = themeKey ? THEME_PROMPTS[themeKey as ThemeKey] : undefined;
  const siteNamePrompt = siteName
    ? `Name the site "${siteName}" and use this name consistently throughout the site.`
    : undefined;

  return [categoryPrompt, themePrompt, siteNamePrompt].filter(Boolean).join('\n');
}
